import type {
  DefaultError,
  UseMutationOptions,
} from '@tanstack/react-query'
import type {
  AddCartItemResponse,
  CartItemPostData,
} from '~/lib/services/api/cart'

import {
  useMutation,
} from '@tanstack/react-query'
import {
  addCartItem,
} from '~/lib/services/api/cart'

function useAddCartItem() {
  const mutationFn = async (data: CartItemPostData) => {
    const response = await addCartItem(data)
    if (response.status !== 200)
      throw new Error('Error adding item to cart')
    return response.data
  }

  const options: UseMutationOptions<
    AddCartItemResponse,
    DefaultError,
    CartItemPostData,
    unknown
  > = {
    mutationFn,
    onSuccess: () => {
      try {
        sessionStorage.setItem(
          'lastConfiguratorRoute',
          window.location.pathname,
        )
      }
      catch (error) {
        console.warn('Could not store configurator route:', error)
      }
    },
  }

  return useMutation(options)
}

export default useAddCartItem
